/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Link } from 'react-router-dom';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import BombiixModal from '../../../Components/BombiixModal/BombiixModal';
import './CompletionModal.css';

const MAX_TITLE_NUMBER_LENGTH = 12;

function CompletionModal({ item, show, handleClose, completionData }) {
  const { t } = useTranslation('common');

  const productNumber = item?.number || '';
  const truncatedNumber = productNumber.length > MAX_TITLE_NUMBER_LENGTH ? `${productNumber.slice(0, MAX_TITLE_NUMBER_LENGTH)}...` : productNumber;

  const modules = completionData?.trafficColorDetails?.measurement
    ? [
        { key: 'design', name: 'Design Details', url: 'design-details/list' },
        { key: 'bom', name: 'BOM', url: 'bom' },
        { key: 'measurement', name: 'Measurements', url: 'measurement' },
        { key: 'testing', name: 'Testing', url: 'testing/testing-requirements' },
        { key: 'care', name: 'Care Labels', url: 'care-user-instruction' },
        { key: 'samples', name: 'Samples', url: 'samples' },
        { key: 'costing', name: 'Costing', url: 'product-costing' },
        { key: 'po', name: 'Purchase Orders', url: 'product-purchase-order' },
      ]
    : [
        { key: 'design', name: 'Design Details', url: 'design-details/list' },
        { key: 'bom', name: 'BOM', url: 'bom' },
        { key: 'testing', name: 'Testing', url: 'testing/testing-requirements' },
        { key: 'care', name: 'Care Labels', url: 'care-user-instruction' },
        { key: 'samples', name: 'Samples', url: 'samples' },
        { key: 'costing', name: 'Costing', url: 'product-costing' },
        { key: 'po', name: 'Purchase Orders', url: 'product-purchase-order' },
      ];

  const dynamicModuleKeys = Object.keys(completionData?.trafficColorDetails);
  const newKeysToAdd = dynamicModuleKeys?.filter((key) => !modules.some((module) => module?.key === key));

  newKeysToAdd?.forEach((newKey) => {
    if (newKey !== 'negotiate' && newKey !== 'additionalInformation' && newKey !== 'isComplete') {
      const customId = completionData?.customLibraries.filter((data) => data.moduleName.toLowerCase() === newKey.toLowerCase());
      modules.push({ key: newKey, name: newKey, url: `custom-module/${customId[0]?._id}` });
    }
  });
  const moduleClass = modules.map((ele) => {
    const componentGreen = completionData?.trafficColorDetails[ele.key] === 'green' ? 'green-color' : 'grey-color';
    const componentYellow = completionData?.trafficColorDetails[ele.key] === 'yellow' ? 'yellow-color' : componentGreen;
    const classname = completionData?.trafficColorDetails[ele.key] === 'red' ? 'red-color' : componentYellow;
    ele.class = classname;
    return ele;
  });

  const modalTitle = (
    <span className="completion-modal-title">
      <CustomTooltip tooltipText={productNumber}>
        <span className="completion-modal-title__number">{truncatedNumber}</span>
      </CustomTooltip>
      <span className="completion-modal-title__label">{t('FILTER.COMPLETION_INDECATOR')}</span>
    </span>
  );

  return (
    <BombiixModal show={show} title={modalTitle} onClose={handleClose} hideSave size="md" className="bombiix-modal--completion">
      <ul className="progs-list">
        {checkArray(moduleClass) &&
          moduleClass.map((ele) => {
            return (
              ele?.name !== 'trade-ref' && (
                <li key={ele?.name}>
                  <Link className={ele?.class} to={`/development-order/${item._id}/${ele.url}`}>
                    {ele.name}
                  </Link>
                </li>
              )
            );
          })}
      </ul>
      <div className="py-2  position-relative">
        {completionData?.percentage === '0.00' && <span className="zero-percentage">0 %</span>}
        <ProgressBar className="product-completion" now={completionData?.percentage} label={`${parseFloat(completionData?.percentage)} %`} />
      </div>
    </BombiixModal>
  );
}

export default CompletionModal;
